import { connect } from 'react-redux';
import { AdminAudienceMenu } from '../../components/pages/survey-admin/AdminAudienceMenu';
import { IApplicationState } from '../../store';
import { ActionCreators } from '../../store/SurveyAdminStore';

export const AdminAudienceMenuPage = connect(
	(state: IApplicationState) => ({
		...state.surveyAdmin,
	}),
	{ ...ActionCreators },
)(AdminAudienceMenu);
